const i18n = (function() {
  var SUPPORTED_LANGS = ['en', 'zh'];
  var DEFAULT_LANG = 'en';
  var STORAGE_KEY = 'pod-resizer-lang';
  var currentLang = DEFAULT_LANG;
  var strings = {};
  var translations = {};

  function detectLanguage() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LANGS.indexOf(stored) !== -1) {
      return stored;
    }
    /* Default to English on first visit — ignore browser language */
    return DEFAULT_LANG;
  }

  async function init() {
    /* Preload all translations at init — avoids dynamic import path issues in production */
    var enMod = await import('./i18n/en.json');
    var zhMod = await import('./i18n/zh.json');
    translations.en = enMod.default || enMod;
    translations.zh = zhMod.default || zhMod;
    currentLang = detectLanguage();
    strings = translations[currentLang] || translations[DEFAULT_LANG];
    document.documentElement.lang = currentLang;
    return currentLang;
  }

  function t(key, replacements) {
    replacements = replacements || {};
    var value = strings[key] || key;
    for (var k in replacements) {
      if (replacements.hasOwnProperty(k)) {
        value = value.replace('{{' + k + '}}', replacements[k]);
      }
    }
    return value;
  }

  async function setLanguage(lang) {
    if (SUPPORTED_LANGS.indexOf(lang) === -1) return;
    currentLang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
    strings = translations[lang] || strings;
    document.documentElement.lang = lang;
    document.dispatchEvent(new CustomEvent('langchange', { detail: { lang: lang } }));
  }

  function getLanguage() {
    return currentLang;
  }

  return { init: init, t: t, setLanguage: setLanguage, getLanguage: getLanguage, SUPPORTED_LANGS: SUPPORTED_LANGS };
})();

export default i18n;
